<template>
  <div class="classificacao row align-content--start" v-if="classification !== null">
    <div class="row">
      <div class="flex xs12 sm12 md12 text-center">
        <h1>{{classification.name}}</h1>
      </div>
      <div class="flex xs6 sm6 md6 text-right pr-4">
        <template v-for="(clas, idx) in classification.standings[0].slice(0,10)" >
          <div :key="idx">
            <va-chip class="mb-2 posicao" color="warning">{{posicao(clas.rank)}}</va-chip>
            <va-chip class="mb-2 time" color="warning">{{clas.team.name}}</va-chip>
            <va-chip class="mb-2" color="warning">{{posicao(clas.points)}}</va-chip>
            <va-chip class="mb-2" color="warning">{{posicao(clas.all.played)}}</va-chip>
          </div>
        </template>
      </div>
      <div class="flex xs6 sm6 md6 pl-4">
        <template v-for="(clas, idx) in classification.standings[0].slice(10)">
          <div :key="idx">
            <va-chip class="mb-2" color="warning">{{posicao(clas.rank)}}</va-chip>
            <va-chip class="mb-2 time" color="warning">{{clas.team.name}}</va-chip>
            <va-chip class="mb-2" color="warning">{{posicao(clas.points)}}</va-chip>
            <va-chip class="mb-2" color="warning">{{posicao(clas.all.played)}}</va-chip>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'Classificacao',
  props: {
    camp: {
      type: String,
    },
    temp: {
      type: String,
    },
  },
  apollo: {
    settings: {
      query: gql`
      query MyQuery {
        settings(where:{key:{_in: [
            "Titulo_Live",
            "Sub_Titulo_Live",
            "Hashtag_Live",
            "Temporada_Live",
            "Campeonato_Live"
          ]}}){
          id
          key
          value
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.settings.length > 0) {
            data.settings.forEach((item) => {
              if (item.key.toLowerCase().includes('temporada') && this.temporada === undefined) {
                this.temporada = item.value
              } else if (item.key.toLowerCase().includes('campeonato') && this.campeonato === undefined) {
                this.campeonato = item.value
              }
              this.getLiga()
            })
          }
        }
      },
    },
  },
  data () {
    return {
      temporada: this.temp,
      campeonato: this.camp,
      classification: null,
    }
  },
  methods: {
    posicao (num) {
      return parseInt(num) < 10 ? '0' + num : num
    },
    getLiga () {
      if (this.temporada !== undefined && this.campeonato !== undefined) {
        this.$axios.get(
          `https://api.s1live.com/standings?league=${this.campeonato}&season=${this.temporada}`,
        ).then((value) => {
          this.classification = value.data.response[0].league
        })
      }
    },
  },
  mounted () {
    this.getLiga()
  },
}
</script>

<style scoped>
.classificacao {
  min-height: 100vh;
  background-image: url("../../../assets/background/FUNDO-CLARO-1000.png");
  background-size: cover;
}

.posicao {
  border-radius: 10rem !important;
}

.va-chip {
  font-size: unset !important;
  line-height: unset !important;
  background: rgb(255, 214, 82) !important;
  color: black !important;
}

.time {
  width: 300px;
}

h1 {
  padding-top: 4px;
  padding-right: 20px;
  color: #f5ce4f;
  font-size: 45px;
  font-family: "Menlo", monospace;
}
</style>
